module.exports = require("./nmg.d.ts");